import { captureWarning } from '~/lib/metrics';

/**
 * Temporary diagnostic for IBUG-2599.
 *
 * A search request that never answers currently emits nothing: `getSearchToken` has no timeout,
 * and the callers only clear their loading flag when the promise settles. So the user watches a
 * spinner and Sentry sees silence. Every other failure mode already reports itself.
 *
 * This reports a warning if `promise` has not settled in 12s (above the edge's ~10s worst-case,
 * so it does not fire on merely slow requests). Observational only - nothing is aborted and the
 * returned promise resolves and rejects exactly as the original does.
 */
export function warnIfStalled<T>(promise: Promise<T>, stage: 'token' | 'search'): Promise<T> {
  const timer = setTimeout(
    () => captureWarning(`Search stalled: "${stage}" did not respond`, { 'search-stalled': stage }),
    12000
  );
  return promise.finally(() => clearTimeout(timer));
}
